addOnload(() => {
    const myKarpus = new Karpus()

    myKarpus.debugging = false

    const handleNotifications = myKarpus.handleNotifications();
    const desktopMenu = myKarpus.handleDesktopMenu()
    const mobileMenu = myKarpus.handleMobileMenu()
    const owlCarousel = myKarpus.handleOwlCarousel()
    const navHeadingLinks = myKarpus.handleMenuHeadingLinks()
    const hoverables = myKarpus.handleHoverables()
    const calcedSizes = myKarpus.handleCalcChildSize()
});

let requireSecure = !/myftpupload|localhost/.test(document.location.href) || false;
let cookieDomain = '.citlon.com';
let siteDomain = 'citlon.com';

// Determine cookie domain
switch( true ) {
    case /localhost/.test(document.location.href):
        cookieDomain = '.col-clim.localhost';
        siteDomain = 'dev.col-clim.localhost';
        break;

    case /myftpupload/.test(document.location.href):
        cookieDomain = '.myftpupload.com';
        siteDomain = '101.b87.myftpupload.com';
        break;
}

// Set Notification cookie params
const notification_params = {
    cookie_expire: 7,
    cookie_same_site: 'strict',
    cookie_domain: cookieDomain,
    cookie_path: '/',
    cookie_secure: requireSecure
};

class Karpus {
    menu = {}
    #debug = false
    // preloaded = new Map()

    constructor() { }

    /**
     * @param {boolean} debug
     */
    set debugging(debug) {
        this.#debug = debug
    }

    handleOwlCarousel() {
        const carousel = $('.owl-carousel').owlCarousel({
            dots: true,
            // responsive: true,
            items: 1,
            navigation: true,
            autoplay: true,
            autoplayHoverPause: true,
            loop: true,
            autoplaySpeed: 3,
            animateOut: 'fadeOut'
        })

        return carousel
    }

    handleMobileMenu() {
        const menu = $('.mobile-navigation')
        const nav = $('.navbar-collapse', menu)
        const toggler = $('.navbar-toggler', menu)
        const navItems = $('.nav-item', menu)
        const navLinks = $('.nav-link:not(.live-link)', navItems)
        const $this = this


        this.#log([navLinks])

        // navLinks.on('click', function(e) {
        //     if( !$(this).hasClass('dropdown-toggle') ) {
        //         $this.#log(['Skipping dropdown'])
        //         return;
        //     }

        //     e.preventDefault();

        //     const dropdownMenu = $('.dropdown-menu', $(this).parent())
        //     dropdownMenu.toggleClass('menu-open') //slideToggle(250)
        //     // allDropdownMenus.not(dropdownMenu).slideUp(350)

        // })

        // Cancel Clicks
        navLinks.each(function () {
            $(this)
                .off('mouseenter')
                .on('click', function (e) {
                    if (!$(this).hasClass('dropdown-toggle')) {
                        $this.#log(['Skipping dropdown'])
                        return;
                    }

                    e.preventDefault();

                    const dropdownMenu = $('.dropdown-menu', $(this).parent())
                    dropdownMenu.toggleClass('show') //slideToggle(250)
                    $('.dropdown-menu', navItems).not(dropdownMenu).removeClass('show')

                })
        })

        toggler
            .off('mouseenter')
            .on('click', function (e) {
                $(this).toggleClass('open')

                nav
                    .toggleClass('show')
                    .css({
                        top: `${menu.height()}px`
                    })
            })

        // Do other stuff
        return menu;
    }

    handleDesktopMenu() {
        const menu = $('.desktop-navigation')
        const dropdowns = $('.dropdown', menu)
        const offsets = new Map()
        const $this = this

        this.#log([menu])

        dropdowns.each(function () {
            const menu = $('.dropdown-menu', this)
            const adjustDropdownMenu = () => {
                if (!offsets.has(menu) || (offsets.get(menu) > ($(window).width() - 15))) {
                    const offset = $(menu).offset().left
                    const width = $(menu).width()
                    const totalOffset = offset + width

                    $this.#log([totalOffset, $(window).width() - 15])

                    if (totalOffset > ($(window).width() - 15)) {
                        menu.css('right', '15px')
                        offsets.set(menu, totalOffset)
                    }
                }
            }

            adjustDropdownMenu()
            $(this).on('mouseenter', adjustDropdownMenu)
        })

        this.#log([menu])

        // Do other stuff
        return menu;
    }

    handleMenuHeadingLinks() {
        const links = $('.nav-heading:not(.live-link)')

        this.#log(['Heading Links', links])

        links.on('click', function (e) {
            e.preventDefault()
        })

        return links
    }


    /**
     * Hoverables must have class hoverable, data-target attribute, and must contain
     * an image with data-target value as class, data-src and data-src-hover attributes
     */
    handleHoverables() {
        const hoverables = $('.hoverable')

        this.#log(hoverables)

        hoverables.on({
            mouseenter: function () {
                let target = $('.' + $(this).attr('data-target'))
                target.attr('src', target.attr('data-src-hover'))
            },
            mouseleave: function () {
                let target = $('.' + $(this).attr('data-target'))
                target.attr('src', target.attr('data-src'))
            }
        })

        return hoverables

    }

    handleCalcChildSize() {
        document.body.style.setProperty("--calc-height", "auto");
        const calcTargets = $('.calc-child-size')

        const resize = () => {
            calcTargets.each(function () {
                let target = $(this);
                let child = $(':first-child', target)
                let size = `${child.outerHeight()}px`;

                if (target.get(0).style.getPropertyValue('--calc-height') !== size) {
                    target.get(0).style.setProperty('--calc-height', size);
                }
            });
        };

        resize();
        $(window).on('resize', resize);
    }

    handleNotifications() {
        const 
            myKarpus = new Karpus(), 
            myCookie = myKarpus.cookie(),
            notification = $('.notification'), 
            mobileNotification = $('.notification-peek');

        // Check for Cookie
        if( myCookie.get('new_site_notification') == 'yes' ) {
            notification.remove();
            mobileNotification.remove();
            return;
        }

        // Clear inline style
        notification.attr('style', '');
        mobileNotification.attr('style', '');

        // Desktop Notification
        notification.each(function() {
            let parent = $(this), notificationClose = $('.notification-close', parent), closeButton = $('button', notificationClose);

            closeButton.on('click', function(e) {
                parent.removeClass('open');
                myCookie.set('new_site_notification', 'yes', notification_params.cookie_expire);
            });
        });

        // Mobile Notification
        mobileNotification.each(function() {
            let 
                parent = $(this), notificationButton = $('button', parent),
                notificationText = $('.notification-peek-inner .text', parent), 
                notificationInstructions = $('.notification-peek-inner .instruct', parent),
                secondaryButton = $('a', notificationInstructions);

            notificationButton.on('click', function(e) {

                myCookie.set('new_site_notification', 'yes', notification_params.cookie_expire);

                let buttonArrow = $('.arrow', this);

                notificationInstructions.toggle(50, function() {
                    notificationText.toggle(250);

                    buttonArrow.toggleClass(function() {
                        if( $(this).hasClass('down') ) {
                            $(this).removeClass('down');
                            return 'up';
                        } else {
                            $(this).removeClass('up');
                            return 'down';
                        }
                    });
                });
                
            });

            secondaryButton.on('click', function() {
                notificationButton.trigger('click');
            });
        });
    }

    cookie() {
		return {
			get: key => {
				const cookieDecoded = decodeURIComponent(document.cookie);
				const cookieData = cookieDecoded.split('; ');
				let resp = false;

				for( let i = 0; i < cookieData.length; i++ ) {
					const data = cookieData[i].split('=');
					
					if( data[0] == key ) {
						resp = data[1];
						break;
					}
				}

				return resp;
			},

			set: (key, val, exp = 0) => {
				const date = new Date(Date.now() + (exp*24*3600*1000));
				date.setUTCHours(0);
				date.setUTCMinutes(0);
				date.setUTCSeconds(0);

				document.cookie = `${key}=${val};domain=${notification_params.cookie_domain};samesite=${notification_params.cookie_same_site};expires=${date.toUTCString()};path=${notification_params.cookie_path};${notification_params.cookie_secure ? 'secure;' : ''}`;
			},

			delete: key => {
				const date = new Date(Date.now() - (10*24*3600*1000));
				document.cookie = `${key}=; expires=${date.toUTCString()}; path=${notification_params.cookie_path}`;
			}
		};
	}

    #log(msg = []) {
        if (this.#debug) {
            console.log(...msg)
        }
    }
}

import 'bootstrap';
import { DefaultHandler } from 'cheerio/node_modules/htmlparser2'
